var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grid is-col-min-15" },
    [
      _vm.innerValue
        ? _c("div", { staticClass: "cell is-flex is-flex-direction-column" }, [
            _c("article", { staticClass: "box is-flex-grow-1" }, [
              _c("p", { staticClass: "title" }, [_vm._v("Rates")]),
              _vm.isNtar
                ? _c("div", { staticClass: "field is-horizontal" }, [
                    _c("div", { staticClass: "field-body" }, [
                      _vm._m(0),
                      _c("div", { staticClass: "field-body" }, [
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "div",
                            {
                              staticClass: "control",
                              class: {
                                "is-loading": _vm.savingFields.shopRate,
                              },
                            },
                            [
                              _c("vue-numeric", {
                                directives: [
                                  {
                                    name: "focus-inserted",
                                    rawName: "v-focus-inserted",
                                  },
                                ],
                                staticClass: "input has-text-right",
                                attrs: {
                                  min: 0,
                                  placeholder: "Shop Rate",
                                  precision: 2,
                                  disabled:
                                    _vm.innerValue.readOnly ||
                                    _vm.readOnlyView ||
                                    _vm.savingFields.shopRate,
                                },
                                on: {
                                  focus: function ($event) {
                                    return _vm.captureFieldSnapshot("shopRate")
                                  },
                                  blur: function ($event) {
                                    return _vm.handleFieldBlur("shopRate")
                                  },
                                },
                                model: {
                                  value: _vm.innerValue.shopRate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.innerValue, "shopRate", $$v)
                                  },
                                  expression: "innerValue.shopRate",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              !_vm.isNtar
                ? _c(
                    "div",
                    [
                      _vm._l(_vm.labourCodeTypes, function (codeType) {
                        return _c(
                          "div",
                          {
                            key: codeType.order,
                            staticClass: "field is-horizontal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field-label is-normal" },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getLabourColumnName(codeType.code)
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c("div", { staticClass: "field-body" }, [
                              _c("div", { staticClass: "field" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass: "control",
                                    class: {
                                      "is-loading":
                                        _vm.ratesSaving[codeType.code],
                                    },
                                  },
                                  [
                                    _c("vue-numeric", {
                                      staticClass: "input has-text-right",
                                      attrs: {
                                        min: 0,
                                        placeholder: _vm.getLabourColumnName(
                                          codeType.code
                                        ),
                                        precision: 2,
                                        disabled:
                                          _vm.innerValue.readOnly ||
                                          _vm.readOnlyView ||
                                          _vm.ratesSaving[codeType.code],
                                      },
                                      on: {
                                        focus: function ($event) {
                                          return _vm.captureRateSnapshot(
                                            codeType.code
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.handleRateBlur(
                                            codeType.code
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.getLabourRate(codeType.code)
                                          .rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.getLabourRate(codeType.code),
                                            "rate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "getLabourRate(codeType.code).rate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      _vm._l(_vm.otherLabourCodeTypes, function (codeType) {
                        return _c(
                          "div",
                          {
                            key: codeType.order,
                            staticClass: "field is-horizontal",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field-label is-normal" },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getLabourColumnName(codeType.code)
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c("div", { staticClass: "field-body" }, [
                              _c("div", { staticClass: "field" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass: "control",
                                    class: {
                                      "is-loading":
                                        _vm.ratesSaving[codeType.code],
                                    },
                                  },
                                  [
                                    _c("vue-numeric", {
                                      staticClass: "input has-text-right",
                                      attrs: {
                                        min: 0,
                                        placeholder: _vm.getLabourColumnName(
                                          codeType.code
                                        ),
                                        precision: 2,
                                        disabled:
                                          _vm.innerValue.readOnly ||
                                          _vm.readOnlyView ||
                                          _vm.ratesSaving[codeType.code],
                                      },
                                      on: {
                                        focus: function ($event) {
                                          return _vm.captureRateSnapshot(
                                            codeType.code
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.handleRateBlur(
                                            codeType.code
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.getLabourRate(codeType.code)
                                          .rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.getLabourRate(codeType.code),
                                            "rate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "getLabourRate(codeType.code).rate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      _vm.isRacq
                        ? _c("div", { staticClass: "field is-horizontal" }, [
                            _c("div", { staticClass: "field-body" }, [
                              _vm._m(1),
                              _c("div", { staticClass: "field-body" }, [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "control",
                                      class: {
                                        "is-loading":
                                          _vm.savingFields.paintCons,
                                      },
                                    },
                                    [
                                      _c("vue-numeric", {
                                        staticClass: "input has-text-right",
                                        attrs: {
                                          min: 0,
                                          placeholder: "RACQ Cons.",
                                          precision: 2,
                                          disabled:
                                            _vm.innerValue.readOnly ||
                                            _vm.readOnlyView ||
                                            _vm.savingFields.paintCons,
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.captureFieldSnapshot(
                                              "paintCons"
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.handleFieldBlur(
                                              "paintCons"
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.innerValue.paintCons,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.innerValue,
                                              "paintCons",
                                              $$v
                                            )
                                          },
                                          expression: "innerValue.paintCons",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            !_vm.isNtar
              ? _c("div", [
                  _c("article", { staticClass: "box" }, [
                    _c("p", { staticClass: "title" }, [_vm._v("Paint Rates")]),
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column" },
                        _vm._l(
                          _vm.paintCodeTypes.slice(
                            0,
                            Math.ceil(_vm.paintCodeTypes.length / 2)
                          ),
                          function (codeType, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "field is-horizontal",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "field-label is-normal" },
                                  [
                                    _vm.vehicle
                                      ? _c(
                                          "label",
                                          {
                                            staticClass: "label",
                                            class: {
                                              "has-text-success":
                                                codeType.code ===
                                                _vm.vehicle.paintGroup,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getLabourColumnName(
                                                  codeType.code
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c("div", { staticClass: "field-body" }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "control",
                                        class: {
                                          "is-loading":
                                            _vm.ratesSaving[codeType.code],
                                        },
                                      },
                                      [
                                        _c("vue-numeric", {
                                          staticClass: "input has-text-right",
                                          attrs: {
                                            min: 0,
                                            placeholder:
                                              _vm.getLabourColumnName(
                                                codeType.code
                                              ),
                                            precision: 2,
                                            disabled:
                                              _vm.innerValue.readOnly ||
                                              _vm.readOnlyView ||
                                              _vm.ratesSaving[codeType.code],
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.handleRateBlur(
                                                codeType.code
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.getLabourRate(
                                              codeType.code
                                            ).rate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.getLabourRate(
                                                  codeType.code
                                                ),
                                                "rate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "getLabourRate(codeType.code).rate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "column" },
                        _vm._l(
                          _vm.paintCodeTypes.slice(
                            Math.ceil(_vm.paintCodeTypes.length / 2),
                            _vm.paintCodeTypes.length
                          ),
                          function (codeType, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "field is-horizontal",
                              },
                              [
                                _vm.vehicle
                                  ? _c(
                                      "div",
                                      { staticClass: "field-label is-normal" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "label",
                                            class: {
                                              "has-text-success":
                                                codeType.code ===
                                                _vm.vehicle.paintGroup,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getLabourColumnName(
                                                  codeType.code
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "field-body" }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "control",
                                        class: {
                                          "is-loading":
                                            _vm.ratesSaving[codeType.code],
                                        },
                                      },
                                      [
                                        _c("vue-numeric", {
                                          staticClass: "input has-text-right",
                                          attrs: {
                                            min: 0,
                                            placeholder:
                                              _vm.getLabourColumnName(
                                                codeType.code
                                              ),
                                            precision: 2,
                                            disabled:
                                              _vm.innerValue.readOnly ||
                                              _vm.readOnlyView ||
                                              _vm.ratesSaving[codeType.code],
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.handleRateBlur(
                                                codeType.code
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.getLabourRate(
                                              codeType.code
                                            ).rate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.getLabourRate(
                                                  codeType.code
                                                ),
                                                "rate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "getLabourRate(codeType.code).rate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c("div", { staticClass: "cell is-flex" }, [
        _c("article", { staticClass: "box is-flex-grow-1" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Markups")]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm._m(2),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "control",
                      class: { "is-loading": _vm.savingFields.newMarkup },
                    },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          max: 100,
                          symbol: "%",
                          placeholder: "New Markup %",
                          "symbol-position": "suffix",
                          precision: 2,
                          disabled:
                            _vm.innerValue.readOnly ||
                            _vm.readOnlyView ||
                            _vm.savingFields.newMarkup,
                        },
                        on: {
                          focus: function ($event) {
                            return _vm.captureFieldSnapshot("newMarkup")
                          },
                          blur: function ($event) {
                            return _vm.handleFieldBlur("newMarkup")
                          },
                        },
                        model: {
                          value: _vm.innerValue.newMarkup,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "newMarkup", $$v)
                          },
                          expression: "innerValue.newMarkup",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm._m(3),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "control",
                      class: { "is-loading": _vm.savingFields.usedMarkup },
                    },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          max: 100,
                          symbol: "%",
                          placeholder: "Used Markup %",
                          "symbol-position": "suffix",
                          precision: 2,
                          disabled:
                            _vm.innerValue.readOnly ||
                            _vm.readOnlyView ||
                            _vm.savingFields.usedMarkup,
                        },
                        on: {
                          focus: function ($event) {
                            return _vm.captureFieldSnapshot("usedMarkup")
                          },
                          blur: function ($event) {
                            return _vm.handleFieldBlur("usedMarkup")
                          },
                        },
                        model: {
                          value: _vm.innerValue.usedMarkup,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "usedMarkup", $$v)
                          },
                          expression: "innerValue.usedMarkup",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm._m(4),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "control",
                      class: { "is-loading": _vm.savingFields.recoreMarkup },
                    },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          max: 100,
                          symbol: "%",
                          placeholder: "Recore %",
                          "symbol-position": "suffix",
                          precision: 2,
                          disabled:
                            _vm.innerValue.readOnly ||
                            _vm.readOnlyView ||
                            _vm.savingFields.recoreMarkup,
                        },
                        on: {
                          focus: function ($event) {
                            return _vm.captureFieldSnapshot("recoreMarkup")
                          },
                          blur: function ($event) {
                            return _vm.handleFieldBlur("recoreMarkup")
                          },
                        },
                        model: {
                          value: _vm.innerValue.recoreMarkup,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "recoreMarkup", $$v)
                          },
                          expression: "innerValue.recoreMarkup",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm._m(5),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "control",
                      class: {
                        "is-loading": _vm.savingFields.afterMarketMarkup,
                      },
                    },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          max: 100,
                          symbol: "%",
                          placeholder: "Aftermarket %",
                          "symbol-position": "suffix",
                          precision: 2,
                          disabled:
                            _vm.innerValue.readOnly ||
                            _vm.readOnlyView ||
                            _vm.savingFields.afterMarketMarkup,
                        },
                        on: {
                          focus: function ($event) {
                            return _vm.captureFieldSnapshot("afterMarketMarkup")
                          },
                          blur: function ($event) {
                            return _vm.handleFieldBlur("afterMarketMarkup")
                          },
                        },
                        model: {
                          value: _vm.innerValue.afterMarketMarkup,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "afterMarketMarkup", $$v)
                          },
                          expression: "innerValue.afterMarketMarkup",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm._m(6),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "control",
                      class: { "is-loading": _vm.savingFields.exchangeMarkup },
                    },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          max: 100,
                          symbol: "%",
                          placeholder: "Exchange %",
                          "symbol-position": "suffix",
                          precision: 2,
                          disabled:
                            _vm.innerValue.readOnly ||
                            _vm.readOnlyView ||
                            _vm.savingFields.exchangeMarkup,
                        },
                        on: {
                          focus: function ($event) {
                            return _vm.captureFieldSnapshot("exchangeMarkup")
                          },
                          blur: function ($event) {
                            return _vm.handleFieldBlur("exchangeMarkup")
                          },
                        },
                        model: {
                          value: _vm.innerValue.exchangeMarkup,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "exchangeMarkup", $$v)
                          },
                          expression: "innerValue.exchangeMarkup",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm._m(7),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "control",
                      class: {
                        "is-loading": _vm.savingFields.reconditionedMarkup,
                      },
                    },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          max: 100,
                          symbol: "%",
                          placeholder: "Reconditioned %",
                          "symbol-position": "suffix",
                          precision: 2,
                          disabled:
                            _vm.innerValue.readOnly ||
                            _vm.readOnlyView ||
                            _vm.savingFields.reconditionedMarkup,
                        },
                        on: {
                          focus: function ($event) {
                            return _vm.captureFieldSnapshot(
                              "reconditionedMarkup"
                            )
                          },
                          blur: function ($event) {
                            return _vm.handleFieldBlur("reconditionedMarkup")
                          },
                        },
                        model: {
                          value: _vm.innerValue.reconditionedMarkup,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "reconditionedMarkup", $$v)
                          },
                          expression: "innerValue.reconditionedMarkup",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("totals-floating-widget", {
        attrs: {
          active: _vm.isFloatingWidgetActive,
          title: "Totals",
          "rr-total": _vm.rrTotal,
          "repair-total": _vm.repairTotal,
          "rwa-total": _vm.rwaTotal,
          "paint-total": _vm.paintTotal,
          "cd-total": _vm.cdTotal,
          "crush-total": _vm.crushTotal,
          "mech-total": _vm.mechTotal,
          "fg-total": _vm.fgTotal,
          "part-total": _vm.partTotal,
          "opg-total": _vm.opgTotal,
          "total-ex-gst": _vm.innerValue.totalExGst,
        },
        on: {
          "update:active": function ($event) {
            _vm.isFloatingWidgetActive = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Shop Rate")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label" }, [
      _c("label", { staticClass: "label" }, [_vm._v("RACQ Cons.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("New")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Used")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Recore")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Aftermarket")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Exchange")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Reconditioned")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }